@if (isLoading()) {
    <app-loading
        class="m-auto"
        [size]="30" />
} @else if (!hasPermissions()) {
    <div class="flex flex-col items-center justify-center">
        <fa-icon
            class="py-4"
            size="10x"
            [icon]="['fad', 'user-lock']" />
        <h3 class="text-center">{{ 'noProjectPermission' | transloco }}</h3>
        <button
            color="primary"
            mat-raised-button
            (click)="securityService.logout()">
            {{ 'logout' | transloco }}
        </button>
    </div>
}
